// src/floormaps/desks.js
// Sumber peta lantai (kursi + opsi garis dinding + opsi background image)

// ---- Seats (desk coordinates) ----
import FLOOR_1_SEATS from './Floor_1_seats.json';
import FLOOR_1S_SEATS from './Floor_1_Split_seats.json';
import FLOOR_2_SEATS from './Floor_2_seats.json';

// ---- Walls (lines) ----
import FLOOR_1_WALLS from './Floor_1_walls.json';
import FLOOR_1S_WALLS from './Floor_1_Split_walls.json';
import FLOOR_2_WALLS from './Floor_2_walls.json'; // (tidak dipakai untuk render, tapi boleh dibiarkan)

// ---- Background images (OPSI A) ----
import IMG_F1 from '../assets/Floor_1.png';
import IMG_F1S from '../assets/Floor_1_Split.png';
import IMG_F2 from '../assets/Floor_2.png';

const DEFAULT_WIDTH = 1800;
const DEFAULT_HEIGHT = 1000;

function extractSeats(seatsJson) {
  if (!seatsJson) return [];
  if (Array.isArray(seatsJson)) return seatsJson;
  if (Array.isArray(seatsJson.seats)) return seatsJson.seats;
  return [];
}
function extractWalls(wallsJson) {
  if (!wallsJson) return [];
  if (Array.isArray(wallsJson)) return wallsJson;
  if (Array.isArray(wallsJson.walls)) return wallsJson.walls;
  return [];
}
function extractSize(seatsJson, wallsJson, bg) {
  const width =
    (seatsJson && !Array.isArray(seatsJson) && seatsJson.width) ||
    (wallsJson && !Array.isArray(wallsJson) && wallsJson.width) ||
    (bg && bg.width) ||
    DEFAULT_WIDTH;

  const height =
    (seatsJson && !Array.isArray(seatsJson) && seatsJson.height) ||
    (wallsJson && !Array.isArray(wallsJson) && wallsJson.height) ||
    (bg && bg.height) ||
    DEFAULT_HEIGHT;

  return { width, height };
}

function composeMap(seatsJson, wallsJson, title, bg) {
  const seats = extractSeats(seatsJson);
  const walls = extractWalls(wallsJson);
  const { width, height } = extractSize(seatsJson, wallsJson, bg);
  return {
    title,
    building: 'Main Building',
    width,
    height,
    seats,
    walls,                 // akan kosong [] jika wallsJson = null
    wallStroke: '#374151', // warna garis jika walls ada
    bg,                    // { url, width, height, x?, y?, opacity? } atau null
  };
}

// --- KONFIGURASI LANTAI ---
// Floor 1 & Floor 2: HAPUS WALLS -> kirim null di parameter wallsJson
// Floor 1 Split: HAPUS BG -> kirim null di parameter bg
export const DESK_MAPS = {
  'Floor 2': composeMap(
    FLOOR_2_SEATS,
    null, // <-- walls dimatikan
    'Floor 2',
    { url: IMG_F2, width: 2400, height: 1000, opacity: 1 }
  ),
  'Floor 1': composeMap(
    FLOOR_1_SEATS,
    null, // <-- walls dimatikan
    'Floor 1',
    { url: IMG_F1, width: 2400, height: 1000, opacity: 1 }
  ),
  'Floor 1 Split': composeMap(
    FLOOR_1S_SEATS,
    null, // atau FLOOR_1S_WALLS, bebas
    'Floor 1 Split',
    { url: IMG_F1S, width: 1800, height: 1000, x: 0, y: 0, opacity: 0.35 }
  ),

};

// Urutan tombol lantai
export const DESK_FLOOR_ORDER = ['Floor 1', 'Floor 1 Split', 'Floor 2'];
